import React from "react";
import "./VipRequestOverlay.css";
// Close icon removed – using simple text button

export const VipRequestOverlay = ({
  request,
  role,
  isWaiting,
  onAccept,
  onDecline,
  onCancel,
}) => {
  const showHostControls = role === "host" && request?.status === "pending";
  const showViewerCancel = role === "viewer" && isWaiting;

  return (
    <div className="vip-overlay">
      <div className="vip-card">
        <button className="close-btn" onClick={onCancel}>
                    ✖
        </button>
        <h2 className="vip-title">Private Call Request</h2>
        <div className="vip-details">
          <p><strong>From:</strong> {request?.viewer_name}</p>
          <p><strong>Plan:</strong> {request?.minutes} min • {request?.price}</p>
        </div>
        {request?.status && request?.status !== "pending" && (
          <span className={`status-badge ${request.status}`}> 
            {request.status.toUpperCase()}
          </span>
        )}
        {showHostControls && (
          <div className="actions">
            <button className="btn accept" onClick={() => onAccept(request)}>
              Accept &amp; Join VIP
            </button>
            <button className="btn decline" onClick={() => onDecline(request)}>
              Decline
            </button>
          </div>
        )}
        {showViewerCancel && (
          <button className="btn cancel" onClick={onCancel}>
            Cancel Request
          </button>
        )}
      </div>
    </div>
  );
};
